import './index.scss';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import Title from '../title';
import { Grid } from 'antd-mobile';
import { getApps } from '../../services/saas/app';
import { getPlatConfig, getDefaultCover } from '../../utils';
import zdkt from '../../images/ico_zdkt.png';
import sysConfig from '../../sysConfig';
// import mskt from '../../images/ico_mskt.png';
// import mxwlkt from '../../images/ico_mxwlkt.png';
// import zyzx from '../../images/ico_zyzx.png';
const { preRouteUrl } = sysConfig;

function AppCategory() {
  const [categoryList, setCategoryList] = useState([]);
  const history = useHistory();
  const { platformType } = getPlatConfig() || {};
  const { app: appIcon } = getDefaultCover();

  const getSaasCategory = async function () {
    const resp = await getApps();
    if (resp && resp.success && resp.data) {
      setCategoryList(
        resp.data
          .filter((item) => item.apps.length > 0)
          .map((item) => ({
            text: item.categoryName,
            key: item.categoryId,
            apps: item.apps.map((appItem) => ({
              text: appItem.appName,
              key: appItem.appId,
              logo: appItem.appLogo,
              appH5Url: appItem.appH5Url,
              appCode: appItem.appCode,
            })),
          })),
      );
    }
  };

  const getTscloudCategory = async function () {
    setCategoryList([
      {
        text: '教研',
        key: 'edu',
        apps: [
          { text: '教研活动', key: 'zdkt', logo: zdkt, appH5Url: 'code:zdkt', appCode: 'zdkt' },
        ],
      },
    ]);
  };

  useEffect(() => {
    if (platformType === 'saas') {
      getSaasCategory();
    } else if (platformType === 'tscloud') {
      getTscloudCategory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="category">
      {categoryList.map((item) => (
        <div key={item.key}>
          {categoryList.length > 1 ? <Title content={item.text} /> : null}
          <Grid
            columnNum={2}
            hasLine
            data={item.apps}
            square={false}
            onClick={(app) => {
              if (!app.appH5Url) {
                return;
              }
              const isCustom = !app.appH5Url.startsWith('code:');
              let url = app.appH5Url;
              if (app.appH5Url.startsWith('http')) {
                window.location.href = url;
              } else {
                if (isCustom) {
                  url = `${preRouteUrl}${url.startsWith('/') ? url : `/${url}`}`;
                } else {
                  url = `${preRouteUrl}/category/${app.appCode}`;
                }
                history.push(url);
              }
            }}
            renderItem={(app) => (
              <div className="category-item">
                <div className="icon">
                  <img
                    src={app.logo || appIcon}
                    alt={app.text}
                    onError={(e) => e.target.setAttribute('src', appIcon)}
                  />
                </div>
                <p>{app.text}</p>
              </div>
            )}
          />
        </div>
      ))}
    </div>
  );
}

export default AppCategory;
